export default {
  root: ({ props, context, parent }: any) => ({
    class: [
      'dark:!border-gray-800',

      // Shape
      { '!rounded-lg': parent.instance.$name !== 'InputGroup' },

      // Colors
      { 'border-gray-300 dark:!border-gray-600': !props.invalid },

      // States
      {
        'hover:border-primary': !context.disabled && !props.invalid,
        'focus:outline-none focus:outline-offset-0 focus:ring focus:!ring-blue-200/50  dark:focus:!ring-blue-600/50 focus:z-10':
          !context.disabled,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
      },
    ],
  }),
};

// // Shape
